module.exports = __webpack_public_path__ + "img/app_QR_Code.377c65f9.jpg";